import React from 'react'
import {connect} from 'react-redux'
import FilterForm from '../../components/User/FilterForm'
import {updateFilterOptions} from '../../actions/filterOptionActions'

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveFilterOptions: (options) => {
      dispatch(updateFilterOptions(options))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FilterForm)


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/containers/User/FilterFormContainer.jsx